import { render } from "./Library.vue?vue&type=template&id=4194a1d4&scoped=true"
import script from "./Library.vue?vue&type=script&lang=js"
export * from "./Library.vue?vue&type=script&lang=js"

import "./Library.vue?vue&type=style&index=0&id=4194a1d4&scoped=true&lang=css"

import exportComponent from "F:\\desktop2025\\myugcollege\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4194a1d4"]])

export default __exports__